import Home from './home';
import Login from './login';
import Profile from './profile';
import Agency, { RegisterAgency } from './agency';
import Booking, { BidRoute } from './booking';
import Tours from './tours';
import Hotel, { AddHotel, BrowseHotel, RegisterHotel, AddNewHotel } from './hotels';
import Commissions from './commissions';
import Feedback from './feedback';
import AuthRequired from '../components/AuthRequired';
import Notifications from './notification';
import Support,{CreateTicket} from './support';

export const createRoutes = store => [
  Login(store),
  RegisterAgency(store),
  RegisterHotel(store),
  {
    path: '/',
    component: AuthRequired,
    indexRoute: Home(store),
    childRoutes: [
      Profile(store),
      Agency(store),
      BidRoute(store),
      Booking(store),
      AddHotel(store),
      AddNewHotel(store),
      BrowseHotel(store),
      Hotel(store),
      Tours(store),
      Commissions(store),
      Feedback(store),
      Notifications(store),
      Support(store),
      CreateTicket(store)
    ],
  },
];

export default createRoutes;



// WEBPACK FOOTER //
// src/routes/index.js